import { DataState } from '../../types';
import getDataStateStatus from './getDataStateStatus';

export default function createDataStateStatusSelector<T>(state: DataState<T>) {
  return {
    ...state,
    dataStateStatus: getDataStateStatus(state),
  };
}
